export const PROMO_EACH = 100;
export const PROMO_TRIPLE = 300;
export const PROMO_REVIEW_MAP = 50;
export const REFERRAL_INVITER_BONUS = 100;
